import { userIdRegex } from "./Regex";

export default function UserIdValidator(userId: string): boolean {
  return userIdRegex.test(userId);
}
